<template>
  <div class="content-warpper">
    <div class="warpper-title">
      <i class="iconfont iconbaoming"></i>
      学生详情
    </div>
    <div class="padding-sm flex align-center justify-around">
      <div class="volunteer-detail" v-if="stu">
        <div class="border-bottom padding-sm">
          <span class="name">{{ stu.stu_name }}</span>
          <span class=" padding-left font-size-lg">{{ stu.stu_sex===1?'男':'女' }}</span>
          <span class=" padding-left font-size-lg">{{ stu.stu_age }}</span>
          <span class=" padding-left font-size-lg">{{ stu.class_name }}</span>
          <span class=" padding-left font-size-lg">{{ stu.school }}</span>
        </div>
        <div class="border-bottom padding-sm">
          <h2>学习课程:</h2>
          <div>
            <span class="margin-right" v-for="(item,index) in stu.classes" :key="index">{{item}}</span>
          </div>
        </div>
        <div class="border-bottom padding-sm"  >
          <h2 class="flex align-center justify-between">老师评语:

          </h2>
          <div v-for="(item,index) in stu.resumes" :key="index" class="margin-bottom-sm">
            <p>
              {{item.content}}
            </p>
            <p class="flex justify-end" style="color: #999;">
              日期：{{ item.add_time }}
            </p>
          </div>
        </div>
        <div class="flex align-center justify-end padding">
          <el-button type="primary" class="submit-btn" @click="addResumes">新增记录</el-button>
        </div>
      </div>
    </div>
    <el-dialog
        :title="'新增记录'"
        :visible.sync="dialog"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :show-close="false"
        width="600px"
        center>
      <el-form :model="resumesForm" :rules="rules" ref="studentForm">
        <el-form-item prop="content">
          <el-input type="textarea" rows="5" v-model="resumesForm.content" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item class="flex align-center justify-around" label-width="0">
          <el-button class="padding-lr-xl" @click="resetForm('studentForm')">取消</el-button>
          <el-button class="padding-lr-xl" type="primary" @click="submitForm('studentForm')">提交</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>


  </div>
</template>

<script>

import {addStudentResume, studentResume,} from "@/api/fuse";
export default {
  name: "studentDetail",
  data() {
    return {
      stu:null,
      dialog:false,
      resumesForm:{
        content:''
      },
      rules:{
        content: [
          {required: true, message: '请输入评价', trigger: 'blur'},
        ],
      }
    };
  },
  created() {
    this.$emit(
        "setIndex",
        '/fuse/class',
        "当前位置：班级管理 - 学生管理 - 学习记录",
        true
    );
    this.getDetail()
  },
  methods: {
    async getDetail() {
      let _data = await studentResume(this.$route.query.id)
      this.stu = _data.data
    },
    addResumes(){
      this.dialog = true
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
      this.dialog = false
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.submitData(formName)
        }
      });
    },
    async submitData(formName) {
      let _state = await addStudentResume(
          this.$route.query.id,
          this.resumesForm.content
      );
      this.$message.success(_state.msg);
      this.$refs[formName].resetFields();
      this.dialog = false
      this.getDetail()
    }
  }
}
</script>

<style scoped lang="scss">
.volunteer-detail {
  width: 80%;
  border: 1px dashed #999;

  .border-bottom {
    border-bottom: 1px dashed #999;

    .name {
      font-size: 28px;
      font-weight: bold;
      color: #009688;
    }

    h2 {
      font-size: 18px;
      line-height: 42px;
      color: #009688;

      p {
        font-size: 14px;
        color: #666;
        line-height: 30px;
        text-align: right;
        font-weight: normal;
      }
    }

    div {
      line-height: 200%;
      font-size: 16px;

      p {
        text-indent: 32px;

        &.hals-color {
          color: #009688;
          text-indent: 0;
        }
      }
    }
  }
}
</style>